function animateValue(obj) {

    let end = parseInt(obj.dataset.end);

    let current = 0;
    let increment = parseInt(obj.dataset.end / 8);

    let stepTime = 80;
    const objNr = obj.querySelector('span');
    let timer = setInterval(function() {
        current += increment;
        objNr.innerHTML = current.toString();
        if (current > end) {
            objNr.innerHTML = end.toLocaleString('et-EE');
            clearInterval(timer);
        }
    }, stepTime);
}

const scrollingNumbers = [].slice.call(document.querySelectorAll(".countable"));
const numbersObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
        if (entry.isIntersecting) {
            animateValue(entry.target);
            entry.target.parentElement.classList.add('counted');
            numbersObserver.unobserve(entry.target);
        }
    });
});

scrollingNumbers.forEach(function(element) {
    numbersObserver.observe(element);
})

